import { useCallback, ReactNode, useState, memo } from 'react';

import useMount from '@picsart/rc/useMount';

import MasonryColumnVertical from '~/Templates/TaxonomyTemplate/MasonryGridVertical/MasonryColumnVertical';
import MasonryGridVertical from '~/Templates/TaxonomyTemplate/MasonryGridVertical';
import PostPreview from '~/components/PostPreview/PostPreview';
import useRenderOnMobile from '~/hooks/useRenderOnMobile';
import { IPostListItemModel } from '~/models/postModels';
import BaseTemplate, {
  TemplateProps,
} from '~/Templates/BaseTemplate/BaseTemplate';

function TaxonomyTemplate({ analyticsEvent, ...props }: TemplateProps) {
  const [isSSR, setIsSSR] = useState(true);
  const isImagesVisible = useRenderOnMobile();

  useMount(() => {
    setIsSSR(false);
  });

  const renderContent = useCallback<(posts: IPostListItemModel[]) => ReactNode>(
    posts => (
      <MasonryGridVertical
        XL_gridHorizontalGutter={30}
        SM_gridHorizontalGutter={30}
        XL_gridVerticalGutter={30}
        SM_gridVerticalGutter={30}
        XL_columnsCount={2}
        LG_columnsCount={2}
        MD_columnsCount={2}
        SM_columnsCount={1}
        XL_columnSize={1}
        LG_columnSize={1}
        MD_columnSize={1}
        SM_columnSize={1}
        isSSR={isSSR}
      >
        {posts &&
          posts.map((post, index) => (
            <MasonryColumnVertical key={post.id}>
              <PostPreview
                hideImage={!isImagesVisible && index > 0}
                onClick={analyticsEvent}
                preload={index === 0}
                position={index + 1}
                post={post}
              />
            </MasonryColumnVertical>
          ))}
      </MasonryGridVertical>
    ),
    [analyticsEvent, isSSR, isImagesVisible],
  );

  return <BaseTemplate {...props} renderContent={renderContent} />;
}

export default memo<TemplateProps>(TaxonomyTemplate);
